import { iconMap, isIconKey } from "@theme/.generated/icon-map";

import { Flex, Text } from "@theme/components";

import type { StrapiValuePropProps } from "@ms/gatsby-site/src/types/strapi";
import type { FC } from "react";

export const ValueProp: FC<StrapiValuePropProps> = ({ icon, label }) => {
  const Icon = isIconKey(icon.key) && iconMap[icon.key];

  return (
    <Flex
      sx={{
        flexDirection: ["column", null, "row"],
        alignItems: "center",
        justifyContent: "center",
        textAlign: ["center", null, "left"],
        gap: "s300",
        color: "textLevel2",
      }}
    >
      {Icon && (
        <Icon
          sx={{
            minWidth: ["iconSizeMd", null, "iconSizeLarge"],
            width: ["iconSizeMd", null, "iconSizeLarge"],
            height: ["iconSizeMd", null, "iconSizeLarge"],
          }}
        />
      )}
      <Text variant="sansMicro02MediumPlus">{label}</Text>
    </Flex>
  );
};
